import { IconButton, Tooltip } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';
import React from 'react';
import useBundleTranslation from 'i18n';
import { useEmbeddingContextVisible } from 'hooks/useEmbeddingContext';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { dispatchCustomEvent } from 'tools/events';
import { ElementType } from 'components/element-viewer/index';

export default function ExternalLinkButton({
    externalLink,
    externalLinkTitle,
    element,
    segmentValueId,
}: {
    externalLink: string;
    externalLinkTitle?: string;
    element?: ElementType;
    segmentValueId?: number;
}) {
    const { t } = useBundleTranslation(['components/common/viewer_controls_panel']);

    const hasIOpenExtContext = useEmbeddingContextVisible('iOpenExt');
    const hasOpenExternalReportButton = useEmbeddingContextVisible('control_buttons.open_external_report');
    const hasIcon = hasIOpenExtContext && hasOpenExternalReportButton;

    const customEvents = useSelector((state: RootState) => state.elementViewer.customEvents);
    const isApp = useSelector((state: RootState) => state.elementViewer.isApp);

    if (!hasIcon) {
        return null;
    }

    const handleClick = (event: React.MouseEvent) => {
        if (isApp && customEvents && customEvents.external_link_click) {
            event.preventDefault();
            dispatchCustomEvent('mi-element-viewer', {
                action: 'external-link-click',
                payload: {
                    url: externalLink,
                    elementInfo: element,
                },
            });
        } else {
            window.open(externalLink, '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <span data-test={'top-external-link-icon'}>
            <Tooltip title={externalLinkTitle ?? t('open_external_report_btn_tooltip')}>
                <IconButton sx={{ p: '6px' }} onClick={handleClick}>
                    <IconMi icon="external-link" fontSize="16" />
                </IconButton>
            </Tooltip>
        </span>
    );
}
